import { getAuthHeader } from '../../../utils/auth';

const BASE_URL = process.env.REACT_APP_DHIS2_BASE_URL || '';

// Helper function to get auth from localStorage or create a default
const getAuth = () => {
  const storedAuth = localStorage.getItem('auth');
  if (storedAuth) {
    return JSON.parse(storedAuth);
  }
  
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) {
    return { token };
  }
  
  return {};
};

export async function fetchUserProfile() {
  const auth = getAuth();
  
  try {
    const response = await fetch(`${BASE_URL}/api/me`, {
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(auth)
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch user profile: ${response.status}`);
    }

    const data = await response.json();
    
    // Check for stored profile data
    const storedImage = localStorage.getItem('userProfileImage');
    const storedProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    
    return {
      firstName: data.firstName || '',
      lastName: data.surname || '',
      secondName: data.surname || '',
      email: data.email || '',
      phoneNumber: data.phoneNumber || '',
      id: data.id || '',
      bio: storedProfile.bio || '',
      location: storedProfile.location || '',
      profileImage: storedImage || storedProfile.profileImage || ''
    };
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
}

// REMOVED: saveProfileChanges function entirely

// Image upload function (frontend-only, stores in localStorage)
export const uploadProfileImage = async (file) => {
  return new Promise((resolve, reject) => {
    try {
      if (!file || !(file instanceof File)) {
        throw new Error('No valid file provided');
      }

      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        throw new Error('Only JPEG, PNG, GIF, and WebP images are allowed');
      }

      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        throw new Error('Image size must be less than 5MB');
      }

      const reader = new FileReader();
      
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          let width = img.width;
          let height = img.height;
          const maxDimension = 800;
          
          if (width > height && width > maxDimension) {
            height = (height * maxDimension) / width;
            width = maxDimension;
          } else if (height > maxDimension) {
            width = (width * maxDimension) / height;
            height = maxDimension;
          }
          
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          
          const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.8);
          resolve(compressedDataUrl);
        };
        
        img.onerror = () => reject(new Error('Failed to load image'));
      };
      
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
      
    } catch (error) {
      reject(error);
    }
  });
};

// Helper function to get stored profile image
export const getStoredProfileImage = () => {
  return localStorage.getItem('userProfileImage') || '';
};